<template>
	<div class="v5-popup">
		<transition name="v5-mask-fade">
			<div class="v5-popup-mask" v-show="show" @click="hidePopup" v-if="isShowMask" @touchmove="lockScroll($event)"></div>
		</transition>
		<transition :name="`v5-popup-animate-${position}`">
			<div v-show="show" :style="styles" class="v5-popup-content" :class="`${position}`">
				<slot></slot>
			</div>
		</transition>
	</div>
</template>
<script>
	export default {
		name: 'v5-popup',
		props: {
			value: {
				type: Boolean,
				default: false
			},
			isShowMask: {
				type: Boolean,
				default: true
			},
			isLockScroll: {
				type: Boolean,
				default: true
			},
			position: {
				type: String,
				default: 'bottom'
			},
			height: {
				type: String,
				default: 'auto'
			},
			width: String
		},
		watch: {
			value(val) {
				this.show = val;
			},
			show(val) {
				this.$emit('input', val);
			}
		},
		computed: {
			styles() {
				let styles = {
					height: this.height
				};
				if (this.width !== '') {
					styles.width = this.width;
				}
				return styles;
			}
		},
		methods: {
			lockScroll(e) {
				if (this.isLockScroll) {
					e.preventDefault();
					e.stopPropagation();
				}
			},
			hidePopup() {
				this.show = false;
			}
		},
		data() {
			return {
				show: this.value
			};
		}
	};

</script>
<style lang="scss">
	@import './style.scss';

</style>
